export interface AppState {
	lastRequestDateTime: moment.Moment;
}

export const initialState: AppState = {
	lastRequestDateTime: null,
};
